/*
 * JS DISABLED: Responsive table labels are now handled via CSS pseudo-elements in _orders.scss.
 * This script is no longer needed and is kept for reference only.
 *
 *
 * Responsive Tables - Adds data attributes to table cells for better mobile display
 *
(function() {
    document.addEventListener('DOMContentLoaded', function() {
        // Add js-enabled class to body for CSS targeting
        document.body.classList.add('js-enabled');

        // Get all order tables
        const orderTables = document.querySelectorAll('.orders-list');

        orderTables.forEach(function(table) {
            // Get all table headers
            const headers = Array.from(table.querySelectorAll('th')).map(th => th.textContent.trim());

            // Get all table rows
            const rows = table.querySelectorAll('.order-row');

            // For each row, add data-label attribute to each cell
            rows.forEach(function(row) {
                const cells = row.querySelectorAll('td');
                cells.forEach(function(cell, index) {
                    if (headers[index]) {
                        cell.setAttribute('data-label', headers[index]);
                    }
                });
            });
        });
    });
})();
*/
